export default __webpack_public_path__ + "static/media/element_21.9b942814.jpg";